// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
  /* Font sizes */
  --fonts-size-very-small:   10px;
  --fonts-size-small:        12px;
  --fonts-size-medium:       14px;
  --fonts-size-big:          16px;
  --fonts-size-very-big:     20px;
  --fonts-size-extra-large:  30px;
  --fonts-size-texas-large:  40px;

  /* Font weight */
  --fonts-weight-normal:     normal;
  --fonts-weight-bold:       bold;
  --fonts-weight-super-bold: 900;

  /* Font family */
  --fonts-family: "Helvetica Neue",Helvetica,Arial,sans-serif;

  font-size: var(--fonts-size-medium);
  font-family: var(--fonts-family);
  line-height: 1.43;

  /* z-index variables */
  --z-hidden: -1;
  --z-base: 0;
  --z-tooltip: 5;
  --z-over: 6;
  --z-medium: 250;
  --z-high: 500;
  --z-cover-content: 900;
  --z-topbar: 1000;
  --z-modal: 1001;
  --z-portal: 1002;
  --z-select: 1002;
}

/* Increased font sizes in mobile */
@media only screen and (max-width: 768px) {
  html {
    --fonts-size-very-small:  12px;
    --fonts-size-small:       14px;
    --fonts-size-medium:      16px;
    --fonts-size-big:         18px;
    --fonts-size-very-big:    20px;
    --fonts-size-extra-large: 22px;
    --fonts-size-texas-large: 30px;
  }
}

#portal > * {
  z-index: 0 !important;
}

#portal {
  position: relative;
  z-index: var(--z-portal);
}

#modal {
  position: relative;
  z-index: var(--z-modal);
}

.MuiModal-root {
  /* This is done ONLY for AppointmentTooltipContent editor */
  z-index: var(--z-modal) !important;
}

* {
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
}

*:before, *:after {
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
}

a{
  color: var(--link-color);
  cursor: pointer;
  text-decoration: none;
}

a:focus, a:hover{
  /* background-color: var(--background-light-2); */
  color: var(--link-color);
  text-decoration: underline;
  outline: none;
}

a.disabled{
  color:var(--content-1);
  cursor: default;
}

input{
  color: var(--content-4);
}

input.input{
  height: 2em;
  width: 100%;
  padding-left: 0.5em;
  background-color: var(--background-light-1);
  outline: none;
  border: 1px solid var(--content-1);
  border-radius: 6px;
}

input.input:focus{
  border-color: var(--link-color);
}

input:invalid.validated{
  border: 1px solid var(--accent-6) !important;
}

input:disabled{
  background-color: var(--background-light-2);
}

textarea{
  width: 100%;
  color: var(--content-4);
  background-color: var(--background-light-1);
  border: 1px solid var(--content-1);
  border-radius: 6px;
  padding: 0.5em;
  outline: none;
}

textarea:focus{
  border-color: var(--link-color);
}

textarea:disabled{
  background-color: var(--background-light-2);
}

button:not(.fr-btn,.react-datepicker__navigation){
  cursor: pointer;
  border: 0px;
  border-radius: 0.3em;
  box-shadow: 0px 1px 4px 0px var(--content-3);
  line-height: 1em;
  white-space: nowrap;
}

button:hover:not(:disabled){
  filter: brightness(1.07);
}

button:disabled{
  cursor: default;
  background-color: var(--background-light-2) !important;
  color: var(--content-1) !important;
  border: 1px solid var(--background-light-2) !important;
}

button.button-flat{
  height: max-content;
  cursor: pointer;
  background-color: transparent;
  padding: 0.5em;
  border-radius: 6px;
  box-shadow: none;
}
button.button-flat:hover{
  background-color: var(--background-light-1);
}

button.button-medium{
  padding: 0.5em 0.6em;
}

button.button-compact{
  padding: 0.25em 0.3em;
}

button.button-primary{
  border: 1px solid var(--accent-3);
  background-color: var(--accent-3);
  color: var(--background-light-1);
}

button.button-secondary{
  border: 1px solid var(--background-light-1);
  background-color: var(--background-light-1);
  color: var(--content-4);
}

button.button-active{
  border: 1px solid var(--background-dark-1);
  background-color: var(--background-dark-1);
  color: var(--content-1);
}

button.button-accent-1{
  border: 1px solid var(--accent-1);
  color: var(--background-light-1);
  background-color: var(--accent-1);
}
button.button-accent-2{
  border: 1px solid var(--accent-2);
  color: var(--background-light-1);
  background-color: var(--accent-2);
}
button.button-accent-3{
  border: 1px solid var(--accent-3);
  color: var(--background-light-1);
  background-color: var(--accent-3);
}
button.button-accent-4{
  border: 1px solid var(--accent-4);
  color: var(--background-light-1);
  background-color: var(--accent-4);
}
button.button-accent-5{
  border: 1px solid var(--accent-5);
  color: var(--background-light-1);
  background-color: var(--accent-5);
}
button.button-accent-6{
  border: 1px solid var(--accent-6);
  color: var(--background-light-1);
  background-color: var(--accent-6);
}
button.button-accent-7{
  border: 1px solid var(--accent-7);
  color: var(--background-light-1);
  background-color: var(--accent-7);
}
button.button-accent-8{
  border: 1px solid var(--accent-8);
  color: var(--background-light-1);
  background-color: var(--accent-8);
}
button.button-background-dark-1{
  border: 1px solid var(--background-dark-1);
  color: var(--background-light-1);
  background-color: var(--background-dark-1);
}
button.button-background-dark-2{
  border: 1px solid var(--background-dark-2);
  color: var(--background-light-1);
  background-color: var(--background-dark-2);
}
button.button-background-light-1{
  border: 1px solid var(--background-light-1);
  color: var(--content-4);
  background-color: var(--background-light-1);
}
button.button-background-light-2{
  border: 1px solid var(--background-light-2);
  color: var(--content-4);
  background-color: var(--background-light-2);
}

select{
  height: 2em;
  border: 1px solid var(--content-1);
  border-radius: 6px;
  color: var(--content-4);
  outline: none;
  background-color: var(--background-light-1);
}

select:focus{
  border-color: var(--link-color);
}

select:disabled{
  background-color: var(--background-light-2);
}

select.select-primary{
  border: 1px solid var(--accent-3);
  background-color: var(--accent-3);
  color: var(--background-light-1);
}
select.select-accent-1{
  border: 1px solid var(--accent-1);
  color: var(--background-light-1);
  background-color: var(--accent-1);
}
select.select-accent-2{
  border: 1px solid var(--accent-2);
  color: var(--background-light-1);
  background-color: var(--accent-2);
}
select.select-accent-3{
  border: 1px solid var(--accent-3);
  color: var(--background-light-1);
  background-color: var(--accent-3);
}
select.select-accent-4{
  border: 1px solid var(--accent-4);
  color: var(--background-light-1);
  background-color: var(--accent-4);
}
select.select-accent-5{
  border: 1px solid var(--accent-5);
  color: var(--background-light-1);
  background-color: var(--accent-5);
}
select.select-accent-6{
  border: 1px solid var(--accent-6);
  color: var(--background-light-1);
  background-color: var(--accent-6);
}
select.select-accent-7{
  border: 1px solid var(--accent-7);
  color: var(--background-light-1);
  background-color: var(--accent-7);
}
select.select-accent-8{
  border: 1px solid var(--accent-8);
  color: var(--background-light-1);
  background-color: var(--accent-8);
}

table{
  border-collapse: collapse;
}

audio::-webkit-media-controls-panel{
  background-color: var(--background-light-1);
  border-radius: 0px;
}

/*
 * Custom classes
 */

.toast-progress{
  background: none;
  background-color: var(--content-1);
}

.toast-toast{
  min-height: 0px;
  padding: 0px;
  background-color: var(--background-light-1);
  border-radius: 6px;
}

.fade-out {
  animation: fadeOut ease 5s;
  animation-fill-mode: forwards;
}

@keyframes fadeOut {
  0% {
    opacity:1;
  }
  100% {
    opacity:0;
  }
}

@media(hover:none){
  .hover-appear{
    opacity: 1 !important;
  }
}

.hover-appear {
  opacity: 0;
  transition: opacity 0.1s ease-out;
}

.hover-disappear {
  opacity: 1;
  transition: opacity 0.1s ease-out;
}

.hover-container:hover .hover-appear {
  opacity: 1;
}

.hover-container:hover .hover-disappear {
  opacity: 0;
}

/*
 * This allows using nested hover-containers so that the outer
 * one doesn't affect the inner one's control over its children
 */
.hover-container:hover .hover-container:not(:hover) .hover-appear{
  opacity: 0;
}

.hover-container:hover .hover-container:not(:hover) .hover-disappear{
  opacity: 1;
}

.hover-container:hover .hover-highlight {
  background-color: rgba(var(--background-light-2-rgb), 0.4);
}

.hover-background_light_2:hover{
  background-color: var(--background-light-2) !important;
}

.hover-highlight:hover{
  background-color: rgba(var(--background-light-2-rgb), 0.4);
}

.hover-highlight-dark:hover{
  background-color: var(--background-dark-2);
}

.hover-link:hover{
  color: var(--link-color) !important;
}

.hover-float:hover{
  box-shadow: 0 3px 5px rgba(0, 0, 0, 0.15) !important;
  transform: translateY(-1px) !important;
}

.modal-shadow {
  box-shadow: 0px 2px 4px 1px rgba(0, 0, 0, 0.74)
}

/* Scrollbar styles */
@media(min-width: 1200px) {
  ::-webkit-scrollbar{
    width: 8px;
    height: 8px;
  }

  ::-webkit-scrollbar-corner{
    background-color: transparent;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 999px;
    background-color: color(from var(--content-1) srgb r g b / 0.5);
  }

  :hover::-webkit-scrollbar-thumb {
    background-color: color(from var(--content-1) srgb r g b / 0.75);
  }

  ::-webkit-scrollbar-thumb:hover {
    background-color: var(--content-1);
  }

  /* Hidden scrollbar */
  /* Probably not the best UX, better be avoided */
  .hidden-scrollbar::-webkit-scrollbar-thumb {
    background-color: transparent;
  }

  .hidden-scrollbar:hover::-webkit-scrollbar-thumb {
    background-color: color(from var(--content-1) srgb r g b / 0.5);
  }

  .hidden-scrollbar::-webkit-scrollbar-thumb:hover {
    background-color: var(--content-1);
  }
}

.table-header{
  color: var(--background-light-2);
}

.table-header:hover {
  color: var(--background-light-1);
  text-decoration: underline;
}


.table-header-th{
  background-color: var(--background-light-2);
  color: var(--content-4);
  text-transform: uppercase;
  font-family: arial;
  padding: 1em;
  border: 1px solid #DDDCCC;
  font-size: var(--fonts-size-small);
}

.table-header-th:hover{
  filter: brightness(0.95);
}

.trim-gradient{
    position:relative;
    width: 100%;
    max-height: 5.4em;
    overflow:hidden;
}

.trim-gradient:after {
    content:"";
    position:absolute;
    top: 4.4em;
    left: 0;
    height: 1em;
    width:100%;
    background: linear-gradient(rgba(var(--background-light-1-rgb),0), rgba(var(--background-light-1-rgb),1));
}

input[type="date"]::-webkit-calendar-picker-indicator {
  background: transparent;
  color: transparent;
  bottom: 0;
  top: 0;
  right: 0;
  left: 0;
  width: auto;
  height: auto;
  cursor: pointer;
  position: absolute
}

input[type="date"]{
  position: relative
}

.actionbtn {
  background: transparent;
  cursor: pointer;
  text-align: left;
  padding: 1em;
}

.actionbtn:hover {
  background: var(--background-light-1);
}

/* react-json-view */
.w-rjv-line {
  padding: 3px 0;
}
.w-rjv-inner {
  padding: 3px 0;
}
`, "",{"version":3,"sources":["webpack://./shared/index.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;;EAE/B,gBAAgB;EAChB,iCAAiC;EACjC,+BAA+B;EAC/B,8BAA8B;;EAE9B,gBAAgB;EAChB,2DAA2D;;EAE3D,mCAAmC;EACnC,gCAAgC;EAChC,iBAAiB;;EAEjB,sBAAsB;EACtB,cAAc;EACd,WAAW;EACX,cAAc;EACd,WAAW;EACX,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,mCAAmC;AACnC;EACE;IACE,8BAA8B;IAC9B,8BAA8B;IAC9B,8BAA8B;IAC9B,8BAA8B;IAC9B,8BAA8B;IAC9B,8BAA8B;IAC9B,8BAA8B;EAChC;AACF;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,2DAA2D;EAC3D,kCAAkC;AACpC;;AAEA;EACE,sBAAsB;EACtB,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,iDAAiD;EACjD,wBAAwB;EACxB,0BAA0B;EAC1B,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,2CAA2C;EAC3C,aAAa;EACb,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,2CAA2C;EAC3C,kCAAkC;EAClC,kBAAkB;EAClB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,eAAe;EACf,WAAW;EACX,oBAAoB;EACpB,4CAA4C;EAC5C,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,sDAAsD;EACtD,kCAAkC;EAClC,sDAAsD;AACxD;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,6BAA6B;EAC7B,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,2CAA2C;AAC7C;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iCAAiC;EACjC,iCAAiC;EACjC,gCAAgC;AAClC;;AAEA;EACE,2CAA2C;EAC3C,2CAA2C;EAC3C,uBAAuB;AACzB;;AAEA;EACE,0CAA0C;EAC1C,0CAA0C;EAC1C,uBAAuB;AACzB;;AAEA;EACE,iCAAiC;EACjC,gCAAgC;EAChC,iCAAiC;AACnC;AACA;EACE,iCAAiC;EACjC,gCAAgC;EAChC,iCAAiC;AACnC;AACA;EACE,iCAAiC;EACjC,gCAAgC;EAChC,iCAAiC;AACnC;AACA;EACE,iCAAiC;EACjC,gCAAgC;EAChC,iCAAiC;AACnC;AACA;EACE,iCAAiC;EACjC,gCAAgC;EAChC,iCAAiC;AACnC;AACA;EACE,iCAAiC;EACjC,gCAAgC;EAChC,iCAAiC;AACnC;AACA;EACE,iCAAiC;EACjC,gCAAgC;EAChC,iCAAiC;AACnC;AACA;EACE,iCAAiC;EACjC,gCAAgC;EAChC,iCAAiC;AACnC;AACA;EACE,0CAA0C;EAC1C,gCAAgC;EAChC,0CAA0C;AAC5C;AACA;EACE,0CAA0C;EAC1C,gCAAgC;EAChC,0CAA0C;AAC5C;AACA;EACE,2CAA2C;EAC3C,uBAAuB;EACvB,2CAA2C;AAC7C;AACA;EACE,2CAA2C;EAC3C,uBAAuB;EACvB,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,kCAAkC;EAClC,kBAAkB;EAClB,uBAAuB;EACvB,aAAa;EACb,2CAA2C;AAC7C;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,iCAAiC;EACjC,iCAAiC;EACjC,gCAAgC;AAClC;AACA;EACE,iCAAiC;EACjC,gCAAgC;EAChC,iCAAiC;AACnC;AACA;EACE,iCAAiC;EACjC,gCAAgC;EAChC,iCAAiC;AACnC;AACA;EACE,iCAAiC;EACjC,gCAAgC;EAChC,iCAAiC;AACnC;AACA;EACE,iCAAiC;EACjC,gCAAgC;EAChC,iCAAiC;AACnC;AACA;EACE,iCAAiC;EACjC,gCAAgC;EAChC,iCAAiC;AACnC;AACA;EACE,iCAAiC;EACjC,gCAAgC;EAChC,iCAAiC;AACnC;AACA;EACE,iCAAiC;EACjC,gCAAgC;EAChC,iCAAiC;AACnC;AACA;EACE,iCAAiC;EACjC,gCAAgC;EAChC,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;;EAEE;;AAEF;EACE,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE;IACE,SAAS;EACX;EACA;IACE,SAAS;EACX;AACF;;AAEA;EACE;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE,UAAU;EACV,iCAAiC;AACnC;;AAEA;EACE,UAAU;EACV,iCAAiC;AACnC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;;;EAGE;AACF;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,0DAA0D;AAC5D;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,0DAA0D;AAC5D;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,oDAAoD;EACpD,sCAAsC;AACxC;;AAEA;EACE;AACF;;AAEA,qBAAqB;AACrB;EACE;IACE,UAAU;IACV,WAAW;EACb;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,oBAAoB;IACpB,+DAA+D;EACjE;;EAEA;IACE,gEAAgE;EAClE;;EAEA;IACE,kCAAkC;EACpC;;EAEA,qBAAqB;EACrB,gDAAgD;EAChD;IACE,6BAA6B;EAC/B;;EAEA;IACE,+DAA+D;EACjE;;EAEA;IACE,kCAAkC;EACpC;AACF;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,0BAA0B;AAC5B;;;AAGA;EACE,2CAA2C;EAC3C,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,iBAAiB;IACjB,UAAU;IACV,OAAO;IACP,WAAW;IACX,UAAU;IACV,yGAAyG;AAC7G;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,SAAS;EACT,MAAM;EACN,QAAQ;EACR,OAAO;EACP,WAAW;EACX,YAAY;EACZ,eAAe;EACf;AACF;;AAEA;EACE;AACF;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,qCAAqC;AACvC;;AAEA,oBAAoB;AACpB;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB","sourcesContent":["html {\n  /* Font sizes */\n  --fonts-size-very-small:   10px;\n  --fonts-size-small:        12px;\n  --fonts-size-medium:       14px;\n  --fonts-size-big:          16px;\n  --fonts-size-very-big:     20px;\n  --fonts-size-extra-large:  30px;\n  --fonts-size-texas-large:  40px;\n\n  /* Font weight */\n  --fonts-weight-normal:     normal;\n  --fonts-weight-bold:       bold;\n  --fonts-weight-super-bold: 900;\n\n  /* Font family */\n  --fonts-family: \"Helvetica Neue\",Helvetica,Arial,sans-serif;\n\n  font-size: var(--fonts-size-medium);\n  font-family: var(--fonts-family);\n  line-height: 1.43;\n\n  /* z-index variables */\n  --z-hidden: -1;\n  --z-base: 0;\n  --z-tooltip: 5;\n  --z-over: 6;\n  --z-medium: 250;\n  --z-high: 500;\n  --z-cover-content: 900;\n  --z-topbar: 1000;\n  --z-modal: 1001;\n  --z-portal: 1002;\n  --z-select: 1002;\n}\n\n/* Increased font sizes in mobile */\n@media only screen and (max-width: 768px) {\n  html {\n    --fonts-size-very-small:  12px;\n    --fonts-size-small:       14px;\n    --fonts-size-medium:      16px;\n    --fonts-size-big:         18px;\n    --fonts-size-very-big:    20px;\n    --fonts-size-extra-large: 22px;\n    --fonts-size-texas-large: 30px;\n  }\n}\n\n#portal > * {\n  z-index: 0 !important;\n}\n\n#portal {\n  position: relative;\n  z-index: var(--z-portal);\n}\n\n#modal {\n  position: relative;\n  z-index: var(--z-modal);\n}\n\n.MuiModal-root {\n  /* This is done ONLY for AppointmentTooltipContent editor */\n  z-index: var(--z-modal) !important;\n}\n\n* {\n  box-sizing: border-box;\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n}\n\n*:before, *:after {\n  box-sizing: border-box;\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n}\n\na{\n  color: var(--link-color);\n  cursor: pointer;\n  text-decoration: none;\n}\n\na:focus, a:hover{\n  /* background-color: var(--background-light-2); */\n  color: var(--link-color);\n  text-decoration: underline;\n  outline: none;\n}\n\na.disabled{\n  color:var(--content-1);\n  cursor: default;\n}\n\ninput{\n  color: var(--content-4);\n}\n\ninput.input{\n  height: 2em;\n  width: 100%;\n  padding-left: 0.5em;\n  background-color: var(--background-light-1);\n  outline: none;\n  border: 1px solid var(--content-1);\n  border-radius: 6px;\n}\n\ninput.input:focus{\n  border-color: var(--link-color);\n}\n\ninput:invalid.validated{\n  border: 1px solid var(--accent-6) !important;\n}\n\ninput:disabled{\n  background-color: var(--background-light-2);\n}\n\ntextarea{\n  width: 100%;\n  color: var(--content-4);\n  background-color: var(--background-light-1);\n  border: 1px solid var(--content-1);\n  border-radius: 6px;\n  padding: 0.5em;\n  outline: none;\n}\n\ntextarea:focus{\n  border-color: var(--link-color);\n}\n\ntextarea:disabled{\n  background-color: var(--background-light-2);\n}\n\nbutton:not(.fr-btn,.react-datepicker__navigation){\n  cursor: pointer;\n  border: 0px;\n  border-radius: 0.3em;\n  box-shadow: 0px 1px 4px 0px var(--content-3);\n  line-height: 1em;\n  white-space: nowrap;\n}\n\nbutton:hover:not(:disabled){\n  filter: brightness(1.07);\n}\n\nbutton:disabled{\n  cursor: default;\n  background-color: var(--background-light-2) !important;\n  color: var(--content-1) !important;\n  border: 1px solid var(--background-light-2) !important;\n}\n\nbutton.button-flat{\n  height: max-content;\n  cursor: pointer;\n  background-color: transparent;\n  padding: 0.5em;\n  border-radius: 6px;\n  box-shadow: none;\n}\nbutton.button-flat:hover{\n  background-color: var(--background-light-1);\n}\n\nbutton.button-medium{\n  padding: 0.5em 0.6em;\n}\n\nbutton.button-compact{\n  padding: 0.25em 0.3em;\n}\n\nbutton.button-primary{\n  border: 1px solid var(--accent-3);\n  background-color: var(--accent-3);\n  color: var(--background-light-1);\n}\n\nbutton.button-secondary{\n  border: 1px solid var(--background-light-1);\n  background-color: var(--background-light-1);\n  color: var(--content-4);\n}\n\nbutton.button-active{\n  border: 1px solid var(--background-dark-1);\n  background-color: var(--background-dark-1);\n  color: var(--content-1);\n}\n\nbutton.button-accent-1{\n  border: 1px solid var(--accent-1);\n  color: var(--background-light-1);\n  background-color: var(--accent-1);\n}\nbutton.button-accent-2{\n  border: 1px solid var(--accent-2);\n  color: var(--background-light-1);\n  background-color: var(--accent-2);\n}\nbutton.button-accent-3{\n  border: 1px solid var(--accent-3);\n  color: var(--background-light-1);\n  background-color: var(--accent-3);\n}\nbutton.button-accent-4{\n  border: 1px solid var(--accent-4);\n  color: var(--background-light-1);\n  background-color: var(--accent-4);\n}\nbutton.button-accent-5{\n  border: 1px solid var(--accent-5);\n  color: var(--background-light-1);\n  background-color: var(--accent-5);\n}\nbutton.button-accent-6{\n  border: 1px solid var(--accent-6);\n  color: var(--background-light-1);\n  background-color: var(--accent-6);\n}\nbutton.button-accent-7{\n  border: 1px solid var(--accent-7);\n  color: var(--background-light-1);\n  background-color: var(--accent-7);\n}\nbutton.button-accent-8{\n  border: 1px solid var(--accent-8);\n  color: var(--background-light-1);\n  background-color: var(--accent-8);\n}\nbutton.button-background-dark-1{\n  border: 1px solid var(--background-dark-1);\n  color: var(--background-light-1);\n  background-color: var(--background-dark-1);\n}\nbutton.button-background-dark-2{\n  border: 1px solid var(--background-dark-2);\n  color: var(--background-light-1);\n  background-color: var(--background-dark-2);\n}\nbutton.button-background-light-1{\n  border: 1px solid var(--background-light-1);\n  color: var(--content-4);\n  background-color: var(--background-light-1);\n}\nbutton.button-background-light-2{\n  border: 1px solid var(--background-light-2);\n  color: var(--content-4);\n  background-color: var(--background-light-2);\n}\n\nselect{\n  height: 2em;\n  border: 1px solid var(--content-1);\n  border-radius: 6px;\n  color: var(--content-4);\n  outline: none;\n  background-color: var(--background-light-1);\n}\n\nselect:focus{\n  border-color: var(--link-color);\n}\n\nselect:disabled{\n  background-color: var(--background-light-2);\n}\n\nselect.select-primary{\n  border: 1px solid var(--accent-3);\n  background-color: var(--accent-3);\n  color: var(--background-light-1);\n}\nselect.select-accent-1{\n  border: 1px solid var(--accent-1);\n  color: var(--background-light-1);\n  background-color: var(--accent-1);\n}\nselect.select-accent-2{\n  border: 1px solid var(--accent-2);\n  color: var(--background-light-1);\n  background-color: var(--accent-2);\n}\nselect.select-accent-3{\n  border: 1px solid var(--accent-3);\n  color: var(--background-light-1);\n  background-color: var(--accent-3);\n}\nselect.select-accent-4{\n  border: 1px solid var(--accent-4);\n  color: var(--background-light-1);\n  background-color: var(--accent-4);\n}\nselect.select-accent-5{\n  border: 1px solid var(--accent-5);\n  color: var(--background-light-1);\n  background-color: var(--accent-5);\n}\nselect.select-accent-6{\n  border: 1px solid var(--accent-6);\n  color: var(--background-light-1);\n  background-color: var(--accent-6);\n}\nselect.select-accent-7{\n  border: 1px solid var(--accent-7);\n  color: var(--background-light-1);\n  background-color: var(--accent-7);\n}\nselect.select-accent-8{\n  border: 1px solid var(--accent-8);\n  color: var(--background-light-1);\n  background-color: var(--accent-8);\n}\n\ntable{\n  border-collapse: collapse;\n}\n\naudio::-webkit-media-controls-panel{\n  background-color: var(--background-light-1);\n  border-radius: 0px;\n}\n\n/*\n * Custom classes\n */\n\n.toast-progress{\n  background: none;\n  background-color: var(--content-1);\n}\n\n.toast-toast{\n  min-height: 0px;\n  padding: 0px;\n  background-color: var(--background-light-1);\n  border-radius: 6px;\n}\n\n.fade-out {\n  animation: fadeOut ease 5s;\n  animation-fill-mode: forwards;\n}\n\n@keyframes fadeOut {\n  0% {\n    opacity:1;\n  }\n  100% {\n    opacity:0;\n  }\n}\n\n@media(hover:none){\n  .hover-appear{\n    opacity: 1 !important;\n  }\n}\n\n.hover-appear {\n  opacity: 0;\n  transition: opacity 0.1s ease-out;\n}\n\n.hover-disappear {\n  opacity: 1;\n  transition: opacity 0.1s ease-out;\n}\n\n.hover-container:hover .hover-appear {\n  opacity: 1;\n}\n\n.hover-container:hover .hover-disappear {\n  opacity: 0;\n}\n\n/*\n * This allows using nested hover-containers so that the outer\n * one doesn't affect the inner one's control over its children\n */\n.hover-container:hover .hover-container:not(:hover) .hover-appear{\n  opacity: 0;\n}\n\n.hover-container:hover .hover-container:not(:hover) .hover-disappear{\n  opacity: 1;\n}\n\n.hover-container:hover .hover-highlight {\n  background-color: rgba(var(--background-light-2-rgb), 0.4);\n}\n\n.hover-background_light_2:hover{\n  background-color: var(--background-light-2) !important;\n}\n\n.hover-highlight:hover{\n  background-color: rgba(var(--background-light-2-rgb), 0.4);\n}\n\n.hover-highlight-dark:hover{\n  background-color: var(--background-dark-2);\n}\n\n.hover-link:hover{\n  color: var(--link-color) !important;\n}\n\n.hover-float:hover{\n  box-shadow: 0 3px 5px rgba(0, 0, 0, 0.15) !important;\n  transform: translateY(-1px) !important;\n}\n\n.modal-shadow {\n  box-shadow: 0px 2px 4px 1px rgba(0, 0, 0, 0.74)\n}\n\n/* Scrollbar styles */\n@media(min-width: 1200px) {\n  ::-webkit-scrollbar{\n    width: 8px;\n    height: 8px;\n  }\n\n  ::-webkit-scrollbar-corner{\n    background-color: transparent;\n  }\n\n  ::-webkit-scrollbar-thumb {\n    border-radius: 999px;\n    background-color: color(from var(--content-1) srgb r g b / 0.5);\n  }\n\n  :hover::-webkit-scrollbar-thumb {\n    background-color: color(from var(--content-1) srgb r g b / 0.75);\n  }\n\n  ::-webkit-scrollbar-thumb:hover {\n    background-color: var(--content-1);\n  }\n\n  /* Hidden scrollbar */\n  /* Probably not the best UX, better be avoided */\n  .hidden-scrollbar::-webkit-scrollbar-thumb {\n    background-color: transparent;\n  }\n\n  .hidden-scrollbar:hover::-webkit-scrollbar-thumb {\n    background-color: color(from var(--content-1) srgb r g b / 0.5);\n  }\n\n  .hidden-scrollbar::-webkit-scrollbar-thumb:hover {\n    background-color: var(--content-1);\n  }\n}\n\n.table-header{\n  color: var(--background-light-2);\n}\n\n.table-header:hover {\n  color: var(--background-light-1);\n  text-decoration: underline;\n}\n\n\n.table-header-th{\n  background-color: var(--background-light-2);\n  color: var(--content-4);\n  text-transform: uppercase;\n  font-family: arial;\n  padding: 1em;\n  border: 1px solid #DDDCCC;\n  font-size: var(--fonts-size-small);\n}\n\n.table-header-th:hover{\n  filter: brightness(0.95);\n}\n\n.trim-gradient{\n    position:relative;\n    width: 100%;\n    max-height: 5.4em;\n    overflow:hidden;\n}\n\n.trim-gradient:after {\n    content:\"\";\n    position:absolute;\n    top: 4.4em;\n    left: 0;\n    height: 1em;\n    width:100%;\n    background: linear-gradient(rgba(var(--background-light-1-rgb),0), rgba(var(--background-light-1-rgb),1));\n}\n\ninput[type=\"date\"]::-webkit-calendar-picker-indicator {\n  background: transparent;\n  color: transparent;\n  bottom: 0;\n  top: 0;\n  right: 0;\n  left: 0;\n  width: auto;\n  height: auto;\n  cursor: pointer;\n  position: absolute\n}\n\ninput[type=\"date\"]{\n  position: relative\n}\n\n.actionbtn {\n  background: transparent;\n  cursor: pointer;\n  text-align: left;\n  padding: 1em;\n}\n\n.actionbtn:hover {\n  background: var(--background-light-1);\n}\n\n/* react-json-view */\n.w-rjv-line {\n  padding: 3px 0;\n}\n.w-rjv-inner {\n  padding: 3px 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
